export default "__VITE_ASSET__DjJ4$aEH__"